export const isTransparent = color =>
    color.toLowerCase() === "transparent" || color.toLowerCase() === "none";
